module.exports = __webpack_public_path__ + "static/media/CommissionsTooHigh.d75137cf.png";